<template>
  <div class="vehicleList">
    <el-button size="mini" type="primary" @click="tableInfo()">刷新</el-button>
    <div class="container">
      <div class="table_modle" v-if="showList.findIndex(v => v === 3)>=0"
           :class="[showList.findIndex(v => v === 2)<0?'blockW':'']">
        <div class="tableTitle">
          <span class="Ttitle">装车排队</span>
        </div>
        <el-table border :data="tableLeft" stripe style="width: 100%">
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              <div v-if="scope.row.ifBelongtoSelf"
                   style="background: #0c7cd5;padding: 1px;border-radius: 5px;color: #fff;text-align: center;">我
              </div>
              <div v-else>{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="TankID" label="罐号"/>
          <el-table-column prop="TotalNo" label="队号"/>
          <el-table-column prop="CarNo" label="车号"/>
          <el-table-column prop="StateName" label="状态"/>
        </el-table>
      </div>
      <div class="table_modle" v-if="showList.findIndex(v => v === 2)>=0"
           :class="[showList.findIndex(v => v === 3)<0?'blockW':'']">
        <div class="tableTitle">
          <span class="Ttitle">卸车排队</span>
        </div>
        <el-table border :data="tableRight" stripe style="width: 100%">
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              <div v-if="scope.row.ifBelongtoSelf"
                   style="background: #0c7cd5;padding: 1px;border-radius: 5px;color: #fff;text-align: center;">我
              </div>
              <div v-else>{{scope.$index + 1}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="CarQueueTypeName" label="类别"/>
          <el-table-column prop="TotalNo" label="序号"/>
          <el-table-column prop="CarNo" label="车号"/>
          <el-table-column prop="StateName" label="状态"/>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'vehicleList',
    data() {
      return {
        tableLeft: [],
        tableRight: [],
        showList: [2, 3],
        timeFun: '',
      };
    },
    created() {
      this.tableInfo();
         this.timeFun = setInterval(() => {
           this.tableInfo();
         }, 30000);
    },
    // clearInterval(begin)
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
      }),
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.timeFun);
      next();
    },
    methods: {
      tableInfo() {
        this.userInfor.userType !== "0" ? this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getCarPermission',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.showList = res.bean.map(v => v.OrderType);
        }) : '';
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'listCarList',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.tableRight = res.bean.inCarList;
          this.tableLeft = res.bean.outCarList;
        });
      },
    },
  };
</script>
<style lang="scss">
  .vehicleList {
    width: 100%;
    .container {
      width: 100%;
      display: flex;
      flex: 1;
      flex-direction: row;
      height: calc(100% - 50px);
      .el-table .el-table__body-wrapper{
        height: calc(100% - 25px);
      }
    }
    .blockW {
      width: 100% !important;
    }
    .tableTitle {
      background: rgba(120, 176, 239, 0.3);
      border-radius: 5px 5px 0 0;
      overflow: hidden;
      line-height: 40px;
      margin-top: 10px;
      .Ttitle {
        background: #0095da;
        padding: 0 10px;
        display: inline-block;
        color: white;
        height: 100%;
      }
    }
    .el-table {
      th {
        padding: 5px 0;
        background: rgba(187, 219, 255, 0.3);
        text-align: center;
      }
      td {
        padding: 3px;
      }
    }
    .table_modle {
      display: flex;
      flex: 1;
      flex-direction: column;
      width: 40% !important;
      padding: 0 2%;
    }
  }
</style>
